import { useUndoToast } from '../lib/undoToast.js';

export function UndoSnackbar() {
  const { current, dismiss } = useUndoToast();
  if (!current) return null;
  return (
    <div className="snackbar" role="status" aria-live="polite">
      <span className="snackbar__message">{current.message}</span>
      <button
        type="button"
        className="snackbar__action"
        onClick={() => {
          current.onUndo();
          dismiss();
        }}
      >
        Undo
      </button>
    </div>
  );
}
